<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-primary">
    <div class="container">
      <router-link
        active-class="active"
        class="nav-link"
        to="/">
        <img src="~assets/img/logo.png">
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleMenu"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" ref="nav_collapse">
        <ul class="ml-auto mt-4 mt-md-0 navbar-nav">
          <li class="nav-item mr-3">
            <router-link
              active-class="active"
              @click.native="toggleMenu"
              class="nav-link"
              to="/"
            >Home</router-link>
          </li>
          <li class="nav-item mr-3">
            <router-link @click.native="toggleMenu" class="nav-link" to="/about">Sobre</router-link>
          </li>
          <li class="nav-item mr-3">
            <router-link @click.native="toggleMenu" class="nav-link" to="/#recursos">Recursos</router-link>
          </li>
          <!-- <li class="nav-item mr-3">
            <a class="nav-link" href="#">Cursos Disponíveis</a>
          </li>-->
          <li class="nav-item">
            <router-link
              active-class="active"
              class="nav-link"
              to="/#assine"
              v-smooth-scroll="{ duration: 500, offset: 150 }"
            >Cadastre-se</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: "page-header",
  methods: {
    toggleMenu: function() {
      const class_list = this.$refs.nav_collapse.classList;
      const show_class_name = 'show-mobile';

      if(class_list.contains(show_class_name)) {
        class_list.remove(show_class_name)
      } else {
        class_list.add(show_class_name)
      }

    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/fonts/fonts.css";
@import "~assets/scss/globals.scss";

$toggle-menu-timing-function: cubic-bezier(.25,.1,.25,1);

.navbar-dark {
  .navbar-nav {
    .nav-link {
      @include font-size(16);
      color: #f2f2f2;
    }
  }
}

.collapse.navbar-collapse {
  display: block;

  transition: 
    opacity 400ms $toggle-menu-timing-function,
    max-height 600ms $toggle-menu-timing-function;
  
  max-height: 0;
  opacity: 0;

  &.show-mobile {
    max-height: 200px;
    opacity: 1;
  } 

  @media (min-width: 768px) {
    max-height: 0;
    opacity: initial;
  }
}


</style>




// WEBPACK FOOTER //
// PageHeader.vue?75b3c709